import React, { useEffect, useState } from "react";
import { images } from "../../Images/Svg";
import RadioGroup, { useRadioGroup } from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import style from "./FeedbackForm.module.css";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import HdfcLogo from "../../Images/Svg/Logo.svg";
import { useNavigate, useParams } from "react-router-dom";
import {
  getFeedbackQuestion,
  submitFeedback,
} from "../../Services/feedback.service";
import useToaster from "../../customHook/useToaster";
import { saveToken } from "../../Redux/Slice/loginSlice";
import { useDispatch, useSelector } from "react-redux";
const { feedbackFormSVG } = images;

const rateButton = {
  10: {
    buttonNumber: "10",
    backgroundColor: "#14C15A",
    boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.30)",
  },
  9: {
    buttonNumber: "9",
    backgroundColor: "#7DBC54",
    boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.30)",
  },
  8: {
    buttonNumber: "8",
    backgroundColor: "#B9D251",
    boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.30)",
  },
  7: {
    buttonNumber: "7",
    backgroundColor: "#E5C845",
    boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.30)",
  },
  6: {
    buttonNumber: "6",
    backgroundColor: "#F3BE42",
    boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.30)",
  },
  5: {
    buttonNumber: "5",
    backgroundColor: "#EE9235",
    boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.30)",
  },
  4: {
    buttonNumber: "4",
    backgroundColor: "#E87330",
    boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.30)",
  },
  3: {
    buttonNumber: "3",
    backgroundColor: "#E66034",
    boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.30)",
  },
  2: {
    buttonNumber: "2",
    backgroundColor: "#E45537",
    boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.30)",
  },
  1: {
    buttonNumber: "1",
    backgroundColor: "#E42125",
    boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.30)",
  },
};

const StyledFormControlLabel = styled((props) => (
  <FormControlLabel {...props} />
))(({ theme, checked }) => ({
  //   ".MuiFormControlLabel-label": checked && {
  //     color: "red",
  //   },
}));

function MyFormControlLabel(props) {
  const radioGroup = useRadioGroup();

  let checked = false;

  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }

  return <StyledFormControlLabel checked={checked} {...props} />;
}

const FeedbackForm = () => {
  // const [feedBackQuestion, setFeedBackQuestion] = useState(feedbackFormData);
  const [isActive, setIsActive] = useState(false);
  const [isButtonShadowisActive, setIsButtonShadowisActive] =
    useState(rateButton);
  const [questionsData, setQuestionsData] = useState(null);
  const [questionAnswers, setQuestionAnswers] = useState([]);
  const { showToast } = useToaster();
  const dispatch = useDispatch();
  const { token: isAuthenticated } = useSelector((state) => state.loginSlice);
  const queryParameters = new URLSearchParams(window?.location?.search);
  const caseId = queryParameters.get("case");
  const number = queryParameters.get("mobile");
  const token = queryParameters.get("token");

  const onClickHandler = (e, questionId) => {
    const value = e?.target?.value;
    questionsData?.map((item) => {
      if (item?.question_id === questionId) {
        setQuestionAnswers((prev) => [
          ...prev,
          { question_id: questionId, answer: [value] },
        ]);
      }
    });
  };

  const numberBtnHandler = (buttonNumber, index, questionId) => {
    const questionExists = questionAnswers.some(
      (item) => item.question_id === questionId
    );
    setQuestionAnswers((prev) => {
      if (questionExists) {
        return prev.map((item) =>
          item.question_id === questionId
            ? { ...item, answer: [Number(buttonNumber)] }
            : item
        );
      } else {
        return [
          ...prev,
          { question_id: questionId, answer: [Number(buttonNumber)] },
        ];
      }
    });
    setIsButtonShadowisActive((prevData) => {
      const updatedData = {};
      for (const key in prevData) {
        updatedData[key] = {
          ...prevData[key],
          isBoxShadowActive: key === buttonNumber,
        };
      }
      return updatedData;
    });
  };

  const onSubmitHandler = () => {
    const data = {
      caseId: caseId,
      customerMobileNumber: number,
      questionAnswers: questionAnswers,
    };

    submitFeedback(data)
      .then((res) => {
        if (res?.success)
          showToast(
            res?.message || "Congratulations feedback submitted successfully",
            "success",
            true
          );
      })
      .catch((error) =>
        showToast(error?.message || "Something went wrong", "error", true)
      );
  };

  useEffect(() => {
    dispatch(saveToken(token));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (isAuthenticated) {
      getFeedbackQuestion()
        .then((res) => {
          if (res?.success) {
            setQuestionsData(res?.data);
          }
        })
        .catch((error) =>
          showToast(error?.message || "Something went wrong", "error", true)
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  useEffect(() => {
    const allIdsExist = questionsData?.every((question) => {
      return questionAnswers?.some(
        (answer) => answer?.question_id === question?.question_id
      );
    });

    if (allIdsExist) {
      setIsActive(true);
    }
  }, [questionAnswers, questionsData]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "end",
          paddingLeft: "1rem",
          paddingTop: "1rem",
          marginBottom: "2rem",
          "& .MuiToolbar-root": {},
          "& .MuiPaper-root": {
            backgroundColor: "#FFFFFF",
            color: "#3D4756",
            border: "0px solid #E8E8E8",
          },
          "& .MuiInputBase-root ": { width: "100%" },
        }}
      >
        <img src={HdfcLogo} alt="logo" />
        <Typography sx={{ fontSize: "2.5rem", marginLeft: "1rem" }}>
          CHASE
        </Typography>
      </Box>
      <img src={feedbackFormSVG} alt="feedbackFormSVG" />
      {questionsData?.map((item, index) =>
        item?.feedback_type === "question" ? (
          <div className={style["main_container"]} key={item?.question}>
            <p className={style["p_tag"]}>{item?.question}</p>
            <RadioGroup name="use-radio-group">
              <div className={style["radiobtn_div"]}>
                <MyFormControlLabel
                  labelPlacement="start"
                  value={item?.answer_options[0]}
                  label={
                    <Typography sx={{ fontSize: "18px" }}>
                      {item?.answer_options[0]}
                    </Typography>
                  }
                  control={
                    <Radio
                      sx={{
                        "&.Mui-checked": {
                          color: "#E94D51",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: "18px",
                        },
                      }}
                      onClick={(e) => onClickHandler(e, item?.question_id)}
                    />
                  }
                />
                <MyFormControlLabel
                  labelPlacement="start"
                  value={item?.answer_options[1]}
                  label={
                    <Typography sx={{ fontSize: "18px" }}>
                      {item?.answer_options[1]}
                    </Typography>
                  }
                  control={
                    <Radio
                      sx={{
                        "&.Mui-checked": {
                          color: "#E94D51",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: "18px",
                        },
                      }}
                      onClick={(e) => onClickHandler(e, item?.question_id)}
                    />
                  }
                />
              </div>
            </RadioGroup>
          </div>
        ) : (
          <>
            <p className={style["feedbackRate"]}>{item?.question}</p>
            <div className={style["rate_btn_container"]}>
              {item?.answer_options
                ?.map((number, index) => (
                  <div
                    key={item?.buttonnumber}
                    className={style["rate_btn"]}
                    onClick={() =>
                      numberBtnHandler(number, index, item?.question_id)
                    }
                    style={{
                      color: "white",
                      background:
                        isButtonShadowisActive[number]?.backgroundColor,
                      boxShadow: isButtonShadowisActive[number]
                        ?.isBoxShadowActive
                        ? isButtonShadowisActive[number]?.boxShadow
                        : "",
                    }}
                  >
                    {number}
                  </div>
                ))
                .reverse()}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginLeft: "2.5rem",
                marginRight: "2.5rem",
                marginTop: "1rem",
              }}
            >
              <span style={{ fontSize: "1.25rem", color: "#7DBC54" }}>
                Highest
              </span>
              <span style={{ fontSize: "1.25rem", color: "#E42125 " }}>
                Lowest
              </span>
            </div>
          </>
        )
      )}
      <div
        style={{
          marginTop: "2.5rem",
          width: "30%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <button
          style={{
            fontSize: "2rem",
            padding: " 1.5rem 2.25rem 1.5rem 2.1875rem",
            borderRadius: "20px",
            border: "none",
            backgroundColor: isActive ? "#E42125" : "#f7bdbe",
            boxShadow: isActive ? " 0px 4px 4px 0px rgba(0, 0, 0, 0.25)" : "",
            color: isActive ? "#FFF" : "#E42125",
            marginBottom: "1rem",
            width: "100%",
            fontWeight: "bold",
            disabled: !isActive,
          }}
          onClick={onSubmitHandler}
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default FeedbackForm;
